import { createReducer } from "typesafe-actions";

import {
  FiCatalogResponse,
  FiRecordPaneChart,
} from "@mapmycustomers/shared/types/entity/fieldInsight";

import { Actions, closeRecordChart, fetchRecordCharts, openRecordChart } from "./actions";

export interface RecordChartsState {
  charts: FiRecordPaneChart[];
  error: unknown;
  loading: boolean;
  openChartId: FiCatalogResponse["id"] | undefined;
}

const initialState: RecordChartsState = {
  charts: [],
  error: undefined,
  loading: false,
  openChartId: undefined,
};

const recordCharts = createReducer<RecordChartsState, Actions>(initialState)
  // Cleared on request: one slot, so kept charts would sit under the next record's name.
  // openChartId goes with them, or a chart left open would reopen under the next record.
  .handleAction(fetchRecordCharts.request, (state) => ({
    ...state,
    charts: [],
    error: undefined,
    loading: true,
    openChartId: undefined,
  }))
  .handleAction(fetchRecordCharts.success, (state, { payload }) => ({
    ...state,
    charts: payload.charts,
    loading: false,
  }))
  .handleAction(fetchRecordCharts.failure, (state, { payload }) => ({
    ...state,
    error: payload,
    loading: false,
  }))
  .handleAction(openRecordChart, (state, { payload }) => ({ ...state, openChartId: payload }))
  .handleAction(closeRecordChart, (state) => ({ ...state, openChartId: undefined }));

export type RecordChartsActions = Actions;

export default recordCharts;
